"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _variable = _interopRequireDefault(require("./variable"));
var _GEHelper = require("../../graphicEngine/GEHelper");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SttVariable = /*#__PURE__*/function (_Variable) {
  function SttVariable(variable) {
    (0, _classCallCheck2["default"])(this, SttVariable);
    Entry.assert(variable.variableType === 'stt', 'Invalid variable type given');
    return _callSuper(this, SttVariable, [variable]);
  }
  (0, _inherits2["default"])(SttVariable, _Variable);
  return (0, _createClass2["default"])(SttVariable, [{
    key: "updateView",
    value: function updateView() {
      if (!this.view_) {
        return;
      }
      if (this.isVisible()) {
        this._adjustSingleViewPosition();
        this.textView_.text = this.getName();
        if (this.isNumber()) {
          var v = Number(this.getValue());
          if (parseInt(this.getValue(), 10) == this.getValue()) {
            this.valueView_.text = v;
          } else {
            this.valueView_.text = Number(v).toFixed(1).replace('.00', '');
          }
        } else {
          this.valueView_.text = this.getValue();
        }
        if (this._nameWidth === null) {
          this._nameWidth = this.textView_.getMeasuredWidth();
        }
        this._adjustSingleValueViewPosition();
        if (this._valueWidth === null) {
          this._valueWidth = this.valueView_.getMeasuredWidth();
        }
        this._adjustSingleViewBox('#8222ff');
      }
      Entry.requestUpdate = true;
    }
  }, {
    key: "_adjustSingleValueViewPosition",
    value: function _adjustSingleValueViewPosition() {
      this.valueView_.x = 12;
      if (_GEHelper.GEHelper.isWebGL) {
        this.valueView_.y = this.GL_VAR_POS.VALUE_Y + 22;
      } else {
        this.valueView_.y = 1.5 + 22;
      }
    }
  }, {
    key: "_adjustSingleViewBox",
    value: function _adjustSingleViewBox(boxFillAndStrokeColor) {
      var rectWidth = Math.max(this._valueWidth + 22, this._nameWidth + 10);
      var colorSet = EntryStatic.colorSet.canvas || {};
      this.rect_.graphics.clear().f('#ffffff').ss(1, 2, 0).s(colorSet.border || '#aac5d5').rr(0, -14, rectWidth, 45, 4);
      this.wrapper_.graphics.clear().f(boxFillAndStrokeColor).ss(1, 2, 0).s(boxFillAndStrokeColor).rr(4, 10, this._valueWidth + 15, 16, this.RECT_RADIUS);
    }

    // @summary 음성 인식(STT) 블록의 종류를 반환합니다.
    // @return {string[]} 음성 인식(STT) 블록의 종류
  }, {
    key: "getSttTypes",
    value: function getSttTypes() {
      if (!this.sttTypes) {
        this.sttTypes = Object.entries(Entry.AI_UTILIZE_BLOCK.audio.getBlocks()).filter(function (_ref) {
          var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            block = _ref2[1];
          return block["class"] === 'stt';
        }).map(function (_ref3) {
          var _ref4 = (0, _slicedToArray2["default"])(_ref3, 1),
            key = _ref4[0];
          return key;
        });
      }
      return this.sttTypes;
    }
  }, {
    key: "checkVisible",
    value: function checkVisible(removeBlock, notIncludeSelf) {
      if (!this.isVisible() || Entry.engine.isState('run')) {
        return;
      }
      var objects = Entry.container.getAllObjects();
      var sttTypes = this.getSttTypes();
      for (var i = 0, len = objects.length; i < len; i++) {
        var code = objects[i].script;
        for (var j = 0; j < sttTypes.length; j++) {
          var blocks = code.getBlockList(false, sttTypes[j]);
          if (notIncludeSelf) {
            var index = blocks.indexOf(removeBlock);
            if (index > -1) {
              blocks.splice(index, 1);
            }
          }
          if (blocks.length > 0) {
            return;
          }
        }
      }
      this.setVisible(false);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setName(Lang.template.voice_title_text);
      this.setValue('-');
    }
  }]);
}(_variable["default"]);
var _default = exports["default"] = SttVariable;